/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UpgradingInputs */

const en_upgrading = /** @type {(inputs: UpgradingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrading…`)
};

const de_upgrading = /** @type {(inputs: UpgradingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird umgestellt…`)
};

/**
* | output |
* | --- |
* | "Upgrading…" |
*
* @param {UpgradingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upgrading = /** @type {((inputs?: UpgradingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UpgradingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrading(inputs)
	return de_upgrading(inputs)
});